<template>
  <div v-touch:swipe="swipeHandler" class="row justify-content-center">
    <template v-for="item in provider.urls">
      <content-static-provider v-if="item.type === undefined || item.type == 1 || item.type == 3" v-bind:key="item.name" :provider="item"/>
      <render-bitcoin v-if="item.type == 2" v-bind:key="item.name" :provider="item"/>
    </template>
  </div>
</template>

<script>
import ContentStaticProvider from "@/components/ContentStaticProvider.vue";
import RenderBitcoin from "@/components/User/Render/RenderBitcoin.vue";

export default {
  name: "ContentStatic",
  components: {
    ContentStaticProvider,
    RenderBitcoin
  },
  props: {
    feeds: Object,
    routeName: String
  },
  computed: {
    provider() {
      let currentCategory = this.$route.params.category;
      let categoryFeeds = this.feeds.items.find(function(data) {
        return data.id == currentCategory;
      });

      if (categoryFeeds === undefined) return { urls: [] };

      return categoryFeeds;
    }
  },
  mounted() {
    //Falls die gewünschte Kategorie leer ist, zu einer mit Inhalt springen
    if (this.provider.urls.length == 0) {
      let categoryWithContent = this.feeds.items.find(function(item) {
        return item.urls.length > 0;
      });

      if (categoryWithContent !== undefined)
        this.$router.push({
          name: this.routeName,
          params: { category: categoryWithContent.id }
        });
    }
  },
  methods: {
    nextCategoryName: function() {
      let categoryName = "";
      let currentCategory = this.$route.params.category;
      let categoryIndex = this.feeds.items.findIndex(function(data) {
        return data.id == currentCategory;
      });

      let indexWithContent = this.feeds.items.findIndex(function(data, index) {
        
        return index > categoryIndex && data.urls.length > 0;
      });

      if ( indexWithContent > -1 ) {
        categoryName = this.feeds.items[indexWithContent].id;
      }

      return categoryName;
    },
    previousCategoryName: function() {
      let categoryName = "";
      let currentCategory = this.$route.params.category;
      let categoryIndex = this.feeds.items.findIndex(function(data) {
        return data.id == currentCategory;
      });

      let indexWithContent = -1; 
      this.feeds.items.findIndex(function(data, index) {
        if (index < categoryIndex && data.urls.length > 0)
          indexWithContent = index;
        return index == categoryIndex;
      });

      if (indexWithContent > -1) {
        categoryName = this.feeds.items[indexWithContent].id;
      }

      return categoryName;
    },
    swipeHandler: function(direction) {
      let currentVisibleProvider = "";

      let activeProviderElement = document.querySelector(
        "#navbar-list li .active"
      );
      if (activeProviderElement != null) {
        currentVisibleProvider = activeProviderElement.getAttribute(
          "data-i42-provider"
        );
      }

      let routeCategory = this.$route.params.category;

      let currentIndex = this.provider.urls.findIndex(data => {
        return data.id == currentVisibleProvider;
      });

      let IsOneProviderVisible = currentVisibleProvider != "";
      //Zurück blättern, wenn schon geblättert wurde
      if (direction == "right" /*&& IsOneProviderVisible*/) {
        currentIndex -= 2;

        if (currentIndex <= 0) {
          let newRouteCategory = this.previousCategoryName();
          this.test = newRouteCategory;
          if (newRouteCategory != "") {
            routeCategory = newRouteCategory;
            currentIndex = 1;

            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

            this.$router.push({
              name: this.routeName,
              params: { category: routeCategory }
            });
          }
        }
        //currentIndex = 0;
        else {
          //window.location = "#p" + this.provider.urls[currentIndex].id;
          let page = "p" + this.provider.urls[currentIndex].id;
          this.$router.push({
            name: this.routeName + "WithPage",
            params: { category: routeCategory, page: page }
          });
        }
      }

      //Vor blättern
      else if (direction == "left") {
        currentIndex += 2;
        if (currentIndex >= this.provider.urls.length) currentIndex--;

        //Wenn noch kein Provider aktiv ist, dann zum ersten springen
        if (!IsOneProviderVisible) {
          currentIndex = 1;
          let page = "p" + this.provider.urls[0].id;
          this.$router.push({
            name: this.routeName + "WithPage",
            params: { category: routeCategory, page: page }
          });
        } else if (currentIndex >= this.provider.urls.length) {
          
          //currentIndex = this.provider.urls.length - 1;
          let newRouteCategory = this.nextCategoryName();
          if (newRouteCategory != "") {
            routeCategory = newRouteCategory;
            currentIndex = 0;

            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

            this.$router.push({
              name: this.routeName,
              params: { category: routeCategory }
            });
          }
        } else {
          let page = "p" + this.provider.urls[currentIndex].id;
          this.$router.push({
            name: this.routeName + "WithPage",
            params: { category: routeCategory, page: page }
          });
        }

        //window.location = "#" + this.provider.urls[currentIndex].id;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
